import API from '../../../../Utils/api';
import useAsync from '../../../../Hooks/useAsync';
import Card from '../../../../Components/Dashboard/Card';
import { CardError, CardLoading } from '../../../../Components/Dashboard/CardState';
import { formatDayMonth } from '../../../../Utils/dates/formatDate';
import styles from '../adminCards.module.css';

const TITLE = 'Account activity';

const AccountActivityCard = () => {
    const { status, data, error, reload } = useAsync(() => API.getAdminAccountActivity().then(res => res.data), []);

    let body;
    if (status === 'loading' && !data) body = <CardLoading label={TITLE} />;
    else if (status === 'error') body = <CardError label={TITLE} status={error?.response?.status} onRetry={reload} />;
    else if (data) {
        const { accounts, lastSignIn, trackingStartedAt } = data;
        const parts = [
            ['within7d', `${lastSignIn.within7d} in the last 7 days`, 'var(--blue-700)'],
            ['d8to30', `${lastSignIn.d8to30} in 8 to 30 days`, 'var(--blue-500)'],
            ['over30d', `${lastSignIn.over30d} over 30 days ago`, 'var(--blue-300)'],
            ['noneRecorded', `${lastSignIn.noneRecorded} with no sign-in recorded`, 'var(--blue-900)'],
            ['noLogin', `${lastSignIn.noLogin} with no login set up`, 'var(--border-strong)']
        ];
        body = (
            <>
                <dl style={{ margin: 0 }}>
                    <div className={styles.kv}><dt>All accounts</dt><dd>{accounts.total}</dd></div>
                    <div className={styles.kv}><dt>Athletes</dt><dd>{accounts.Athlete}</dd></div>
                    <div className={styles.kv}><dt>Coaches</dt><dd>{accounts.Coach}</dd></div>
                    <div className={styles.kv}><dt>Admins</dt><dd>{accounts.Admin}</dd></div>
                </dl>
                <div className={styles.segbar} role="img" aria-label={`Accounts by last sign-in: ${parts.map(p => p[1]).join(', ')}`}>
                    {parts.map(([key, , color]) => (
                        <span key={key} style={{ flex: lastSignIn[key], background: color }} />
                    ))}
                </div>
                <div className={styles.legend}>
                    {parts.map(([key, text, color]) => (
                        <span key={key}><i style={{ background: color }} />{text}</span>
                    ))}
                </div>
                {trackingStartedAt && (
                    <p className={styles.note}>
                        Sign-in tracking started {formatDayMonth(trackingStartedAt)} {new Date(trackingStartedAt).getFullYear()}.
                    </p>
                )}
            </>
        );
    }

    return (
        <Card id="aa" module="admin-activity" title={TITLE} busy={status === 'loading'}>
            {body}
        </Card>
    );
};

export default AccountActivityCard;
